module.exports = __webpack_public_path__ + "img/w13b.e7bd1891.jpg";